import {useFetch} from "../useFetch";
import {TypeWastes} from "../../types/api/guide/typeWastes.types";
import {typeWastesService} from "../../services/guide/typeWastes-service";

export const useFetchGetTypeWasteById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<TypeWastes>(
            typeWastesService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as TypeWastes, isLoading, error };
}